:host {
  height: 100%;
  padding-left: calc(var(--spacer) * 4);
}

.export-wrapper {
  width: 100%;
  height: 100%;
  padding-top: calc(var(--spacer) * 2);
  display: block;

  .content-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;

    .bottom-buttons {
      width: 100%;
      flex-basis: 65px;
      min-height: 65px;
      margin-top: auto;
      display: flex;
      align-items: center;

      border-top: 1px solid var(--surface-1);

      padding-left: calc(var(--spacer) * 4);
      padding-right: calc(var(--spacer) * 4);

      gz-button {
        margin-right: calc(var(--spacer) * 2);

        &#cancel-button {
          margin-left: auto;
          margin-right: 0;
        }
      }
    }
  }
}
